import { render, staticRenderFns } from "./BotPressChat.vue?vue&type=template&id=d94cf804&scoped=true"
import script from "./BotPressChat.vue?vue&type=script&lang=js"
export * from "./BotPressChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94cf804",
  null
  
)

export default component.exports